<template>
  <a
    :id="id"
    :href="item.link"
    :target="item.target"
    :rel="item.target === '_blank' ? 'noopener noreferrer' : ''"
    :class="{ active: isActive }"
    :aria-current="ariaCurrent"
    @click="handleClick"
  >
    {{ item.text }}
  </a>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    currentUrl: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    isActive() {
      return this.currentUrl.lastIndexOf(this.item.link, 0) === 0;
    },
    ariaCurrent() {
      if (this.isActive) {
        return 'page';
      }
      return false;
    }
  },
  methods: {
    handleClick(event) {
      if (this.item.target === '_blank') {
        return;
      }

      event.preventDefault();

      this.$emit('itemSelected', this.item);
    }
  }
};
</script>
